import { render, staticRenderFns } from "./profile-desktop.vue?vue&type=template&id=3c07b016&scoped=true&"
import script from "./profile-desktop.vue?vue&type=script&lang=ts&"
export * from "./profile-desktop.vue?vue&type=script&lang=ts&"
import style0 from "./profile-desktop.vue?vue&type=style&index=0&id=3c07b016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c07b016",
  null
  
)

export default component.exports